import { render, staticRenderFns } from "./VpsPlans.vue?vue&type=template&id=46814a8a&"
import script from "./VpsPlans.vue?vue&type=script&lang=js&"
export * from "./VpsPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports